// @flow
import * as React from 'react';

import { Svg } from '@gandi/ui';

import styles from './CheckMark.scss';

function CheckMark() {
  return <Svg theme="success" name="miniCheckmark" className={styles.icon} />;
}

export default (React.memo<{}>(CheckMark, () => true): React.ComponentType<{}>);
